import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Component from '@plone/volto/components/theme/Component/Component';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import { isManager } from '@plone/volto/helpers/User/User';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { STATUS_VOCABULARY_ID } from '../../../constants';
// import { getVocabulary } from '@plone/volto/actions/vocabularies/vocabularies';
import { getVocabulary } from '../../../actions/vocabularies/vocabularies';
import { getLocations } from '../../../actions';
import { useLocation } from 'react-router-dom';

const GridTemplate = ({ items, linkTitle, linkHref, isEditMode, block }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';
  const user = useSelector((state) => state.users.user);
  const dispatch = useDispatch();
  const currentLang = useSelector((state) => state.intl.locale);
  useEffect(() => {
    dispatch(getLocations(getBaseUrl(`/${currentLang}`)));
    dispatch(
      getVocabulary({
        vocabNameOrURL: STATUS_VOCABULARY_ID,
        locale: currentLang,
      }),
    );
  }, [dispatch, currentLang]);
  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  return (
    <>
      <div className="items">
        {items.map((item) => {
          const ItemBodyTemplate = () => {
            const hasType = item['@type'];
            const CustomItemBodyTemplate = config.getComponent({
              name: 'GridListingItemTemplate',
              dependencies: [hasType],
            }).component;

            return CustomItemBodyTemplate ? (
              <CustomItemBodyTemplate item={item} />
            ) : (
              <div className="card-container">
                {item.image_field !== '' && (
                  <Component
                    componentName="PreviewImage"
                    item={item}
                    alt=""
                    className="item-image"
                  />
                )}
                <div className="item">
                  <div className="content">
                    {item?.head_title && (
                      <div className="headline">{item.head_title}</div>
                    )}

                    <h2>{item?.title}</h2>
                    {!item.hide_description && <p>{item?.description}</p>}
                  </div>
                </div>
              </div>
            );
          };
          return (
            <div className="listing-item" key={item['@id']}>
              <ConditionalLink
                to={
                  queryParams.get(`page_${block.replaceAll('-', '_')}`)
                    ? `${flattenToAppURL(item['@id'])}?paged=page_${block.replaceAll('-', '_')}=${queryParams.get(`page_${block.replaceAll('-', '_')}`)}`
                    : `${flattenToAppURL(item['@id'])}`
                }
                condition={
                  (!isEditMode && item['@type'] !== 'Service') ||
                  (isManager(user) && item['@type'] === 'Service')
                }
              >
                <ItemBodyTemplate item={item} />
              </ConditionalLink>
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

GridTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default GridTemplate;
